// Copyright (c) StrangeBee 2024

import React, { useEffect, useState } from 'react';

interface UseDrawerReturn<T> {
    visible: boolean;
    setVisible: React.Dispatch<React.SetStateAction<boolean>>;
    data?: T;
    setData: React.Dispatch<React.SetStateAction<T | undefined>>;
}

interface UseDrawerProps<T> {
    initialData?: T;
}

export const useDrawer = <T,>({ initialData }: UseDrawerProps<T>): UseDrawerReturn<T> => {
    const [visible, setVisible] = useState(false);
    const [data, setData] = useState(initialData);

    return {
        visible,
        data,
        setData,
        setVisible,
    };
};

const useWatch = <T,>(value: T, callback: (data: T) => void) =>
    useEffect(() => {
        callback(value);
    }, [value]); // eslint-disable-line

useDrawer.watch = useWatch;
